<template>
  <div>
    <b-row class="phone-row mt-5">
      <b-col class="d-flex align-items-center">
        <p>
          {{
            ft(featureName, 'reportingChannels.phoneCall.createDescription', $t)
          }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'PhoneCallForm',
  extends: LocalizableComponent,
  props: {
    onChange: {
      type: Function,
      default: () => {}
    },
    initialFormData: {
      type: Object,
      default: null
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      email: null
    }
  },
  computed: {
    validForm() {
      return true
    }
  },
  mounted() {
    if (this.validForm) {
      this.handleUpdatedFormData()
    }
  },
  methods: {
    handleUpdatedFormData() {
      const formData = {
        message: this.ft(
          this.featureName,
          'reportingChannels.phoneCall.message',
          this.$t
        ),
        email: this.email
      }
      this.onChange({ validForm: this.validForm, formData })
    }
  }
}
</script>
<style scoped></style>
